'use strict';

module.exports = {
    login: {
        service: 'User',
        action: 'memberLogin',
        tagname: 'member_login',
        optHandle: function optHandle(opt) {
            opt.isShowNonMemberLogin = true;
            return opt;
        }
    },
    logout: {
        service: 'User',
        action: 'userLogout',
        tagname: 'user_logout'
    },
    syncLoginFromTouch: false
};


//////////////////
// WEBPACK FOOTER
// ../plugins/ctrip/apis/login.js
// module id = 44
// module chunks = 1 4